// Card / table view mode for the Quests, Locations, NPCs and Items lists.
//
// Deliberately mirrors entitySort.js: same shape, same normalize-on-read
// guard, same reason for existing as a standalone module. Pure and free of
// React/DOM so tests/view-mode.test.js can exercise it in Vitest's `node`
// environment.
//
// Sessions is NOT part of this. Its cards are already a vertical list rather
// than a grid, so a table would buy it almost nothing — it keeps the card
// renderer unconditionally and never mounts a toggle.

export const VIEW_MODES = [
  { id: 'cards', label: 'Cards', icon: '▦' },
  { id: 'table', label: 'Table', icon: '☰' },
]

// Cards, not table. Cards are how you browse a campaign you don't know yet —
// the portrait and the three lines of prose are the point. Table is the view
// you opt into once you already know what you're looking for, so every
// existing user keeps exactly what they have until they ask for otherwise.
export const DEFAULT_VIEW_MODE = 'cards'

export function normalizeViewMode(value) {
  return VIEW_MODES.some((m) => m.id === value) ? value : DEFAULT_VIEW_MODE
}
